export default __webpack_public_path__ + "static/discount-tag-1bfd526ccda31494427b3df459df46a6.webp";